module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-full-f20792cfa4c7f9b1f7982c132be0f34f.webp";